export const DOCTORS_ACTIONS = {
    GET_ALL: 'GET_ALL_DOCTORS',
    GET_ACTIVE: 'GET_ACTIVE_DOCTORS',
    ADD: 'DOCTOR_ADD',
    FIND: 'FIND_DOCTORS',
    CHANGE_STATUS: 'CHANGE_STATUS_DOCTORS',
    SUCCESS: 'SUCCESS_DOCTORS',
    ERROR: 'ERROR_DOCTORS',
    CLEAN: 'CLEAN_DOCTORS',


    SUGGESTION: 'SUGGESTION_DOCTORS',
    SUGGESTION_CLEAN: 'SUGGESTION_CLEAN_DOCTORS',
}